import React, {useContext, useEffect, useState} from "react";
import {FormContext} from "./dynamic-form-context";
import Grid from "@material-ui/core/Grid";
import {AppContext} from "../../app/context";
import { isBase64 } from "../../../utils";
import {addFields} from '../dynamic-field-factory/dynamic-field-factory-component-list';
import { ModalService } from '../../../services/modal-service';
import { pinkA700 } from "material-ui/styles/colors";
import Button, {BUTTON_STYLE} from "../../button";
import { getPackages } from '../../../api';
import { UserService } from "../../../services/user-service";
import { useLocation } from 'react-router-dom';
import { reject } from "lodash";
import { profileService } from 'services/profile-service';
import {getProfile} from "api/index"
import {arrayFiles} from '../fields/form-input-file/form-input-file-context';


let flag = 0;

const validateForm = (formValues, apiFormInfo) => {
    let requiredFields = apiFormInfo.fields
      .filter((field) => {
          return field.required && field.type !== addFields
      })
      .map((field) => field.name);
    const addedFields = apiFormInfo.fields
      .filter((field) => field.required && field.type === addFields)
      .map((field) => field.fields
        .filter((field) => field.required)
        .map((field) => field.name+1)).flat();
    Array.prototype.push.apply(requiredFields, addedFields);
    /*if (Object.keys(formValues).every((key) => formValues[key]['valid'])){
        return requiredFields.every(function(item) {
            return Object.keys(formValues).indexOf(item) !== -1;
        });
    }
    else{
        return false;
    }*/
    const fields = Object.keys(formValues).filter(
        key =>
            formValues[key] &&
            typeof formValues[key] === "object" &&
            "valid" in formValues[key]
    );

    const allValid = fields.every(key => formValues[key].valid);

    if (allValid) {
        return requiredFields.every(item => fields.includes(item));
    }

    return false;

};

const createPayload = (formValues) =>{
    let payload = {};
    const params = new URLSearchParams(window.location.search)
    
    Object.keys(formValues).forEach((key) =>{
        let value = formValues[key]['value'];
        payload[key] = value;
        if(Array.isArray(value)) {
            let list = [];
            let isChangeRequired = false;
            var flg = false;
            value.forEach( (key2) =>{
                if(key2 && Object.hasOwn(key2, 'image') && isBase64(key2.image)){
                    isChangeRequired = true;
                    if (params.has('PACKAGE-ID') ){
                        arrayFiles.forEach(file => {
                            if(file == key){
                                flg = true;
                            }
                        })
                        if(flg){
                            list.push(key2.image);
                        }else{
                            list.push("");
                        }
                    }else{
                        list.push(key2.image);
                    } 
                }
            });

            if(isChangeRequired) {
                payload[key] = list;
            }
        }
    });
    return payload;
};

const requestData = (params) => {
    return getPackages({...params})
};

const submit = (setValidationStyleOn, customSubmit, formValues, apiFormInfo, location) => {
    setValidationStyleOn();
    console.log("LOCACION: " + location.pathname);
    console.log("search:" + location.search);
    //let test =  location.search;
    const packageId = 'PACKAGE-ID=';
    const hasPackageId = location.search.includes(packageId);
    //console.log("TEEEEST" + test);
    console.log(hasPackageId);
    let treatedFilters = Object.assign({});
    if(!hasPackageId && location.pathname == "/capture/" && "PROTOCOLO" in formValues){
        treatedFilters.PROTOCOLO= formValues.PROTOCOLO.value;
        treatedFilters.status = "green,pending,gray,purple,purpleVIP";
        console.log("PARAMETROS: " +treatedFilters);
        requestData(treatedFilters).then((data) => {
            if(data.totalSize >= 1){
            ModalService.changeInfo({
                            show: true,
                            title: ' Precisa seguir com contingência?',
                            text: "Pacote de vendas/serviços já consta liberado. Não é necessário o envio. \n Você pode consultar o pacote deste cliente na opção 'Buscar Pacote'.",
                            closeButton: true,
                            buttons: <Grid container item xs={2} spacing={4} alignItems={'center'} style={{"paddingTop": "10px", "flexFlow": "row", "paddingBottom": "10px",}}>
                                        <Button style={{width: 'fit-content'}} variant={BUTTON_STYLE.DEFAULT_PRIMARY} onClick={() => handleModal2Continue(setValidationStyleOn, customSubmit, formValues, apiFormInfo)}>Sim</Button>
                                        &nbsp;
                                        <Button style={{width: 'fit-content'}} variant={BUTTON_STYLE.DEFAULT_PRIMARY} onClick={() => goHome()}>Não</Button>
                                    </Grid>,
                            spinner: false,
                            callback: () => {},
                            maxWidth: "md",
                          });
        }else{
            if (validateForm(formValues, apiFormInfo)){
                customSubmit(createPayload(formValues), apiFormInfo);
            }
        } 
        },(error)=>console.log(error))
//           
    }else if (validateForm(formValues, apiFormInfo)){
        customSubmit(createPayload(formValues), apiFormInfo);
    }

    const handleModal2Continue = (setValidationStyleOn, customSubmit, formValues, apiFormInfo) => {
        // 1. Cierra el Modal 2
        const roles = UserService.getRoles();
        if(roles.includes("VNBSVSP1") || roles.includes("VNBSVPR1")){
            ModalService.changeInfo({
                show: true,
                title: 'Confirmação',
                text: 'Precisa seguir com contingência?',
                textBottom: '',
                closeButton: true,
                spinner: false,
                buttons: <Grid container item xs={4} spacing={4} alignItems={'center'} style={{"paddingTop": "30px", "flexFlow": "row", "paddingBottom": "30px",}}>
                                        <Button style={{width: 'fit-content'}} variant={BUTTON_STYLE.DEFAULT_PRIMARY} onClick={() => callTDI(setValidationStyleOn, customSubmit, formValues, apiFormInfo)}>Sim</Button>
                                        &nbsp;
                                        <Button style={{width: 'fit-content'}} variant={BUTTON_STYLE.DEFAULT_PRIMARY} onClick={() => goHome()}>Não</Button>
                                    </Grid>,
                maxWidth: 'xs'
            });
            
        }else{
            ModalService.changeInfo({
                show: true,
                title: 'Não autorizado',
                text: 'Não possui autorização para criar pacote',
                textBottom: '',
                closeButton: true,
                spinner: false,
                buttons: <Button style={{width: 'fit-content'}} variant={BUTTON_STYLE.DEFAULT_PRIMARY} onClick={() => goHome()}>OK</Button>,
                maxWidth: 'xs'
            });
            // ModalService.close();
        }
        
    }
    
    };

    const goHome = () => {
        window.location.href = '/';
        ModalService.close();
    }

    const callTDI = (setValidationStyleOn, customSubmit, formValues, apiFormInfo) => {

        if (validateForm(formValues, apiFormInfo)){
            customSubmit(createPayload(formValues), apiFormInfo);
        }
    }


const SubmitButton = ({customSubmit, text}) =>{

    const { apiFormInfo, setValidationStyleOn, formValues } = useContext(FormContext);
    const {language,appmetadata} = useContext(AppContext);
    const location = useLocation();

    useEffect(() => {
        if (location.pathname !== "/capture/") return;

        (async () => {
            let profileData = await getProfile();
            profileService.initI18n(profileData);
            profileService.setLocalization(profileData.localization);
            profileService.setProfile(profileData);
        })();
    }, [location.pathname]);
    
    return (
        <Grid container item xs={12} spacing={3} alignItems={'center'} style={{"paddingTop": "30px", "flexFlow": "column", "paddingBottom": "30px",}}>
            <button className={"form-button form-button-primary"}
                    style={{"width": "20%"}}
                    onClick={()=> {submit(setValidationStyleOn, customSubmit, formValues, apiFormInfo, location)}}>
                {text? text : appmetadata.FORM.SUBMIT[language]}
            </button>
        </Grid>
    )
};

export default SubmitButton;